import { uiTranslations } from '@liza/ui/i18n';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import English translation files
import enAppointments from './locales/en/appointments-translations.json';
import enChat from './locales/en/chat-translations.json';
import enCommon from './locales/en/common-translations.json';
import enRecords from './locales/en/records-translations.json';
import enScheduleAvailability from './locales/en/scheduleAvailability-translations.json';

// Import Spanish translation files
import esAppointments from './locales/es/appointments-translations.json';
import esChat from './locales/es/chat-translations.json';
import esCommon from './locales/es/common-translations.json';
import esRecords from './locales/es/records-translations.json';
import esScheduleAvailability from './locales/es/scheduleAvailability-translations.json';

const resources = {
  en: {
    // Merge UI translations with patient-admin-web translations
    // UI translations provide base, patient-admin-web can override or extend
    appointments: enAppointments,
    chat: { ...uiTranslations.en.chat, ...enChat },
    common: { ...uiTranslations.en.common, ...enCommon },
    records: { ...uiTranslations.en.records, ...enRecords },
    scheduleAvailability: enScheduleAvailability,
    tasks: uiTranslations.en.tasks,
    progress: uiTranslations.en.progress,
  },
  es: {
    // Merge UI translations with patient-admin-web translations
    appointments: esAppointments,
    chat: { ...uiTranslations.es.chat, ...esChat },
    common: { ...uiTranslations.es.common, ...esCommon },
    records: { ...uiTranslations.es.records, ...esRecords },
    scheduleAvailability: esScheduleAvailability,
    tasks: uiTranslations.es.tasks,
    progress: uiTranslations.es.progress,
  },
};

// Initialize i18n and export the promise for tests to await
const initPromise = i18n.use(initReactI18next).init({
  resources,
  lng: 'en', // Default to English for provider view
  fallbackLng: 'en', // Always fall back to English if translation is missing
  supportedLngs: ['en', 'es'],
  nonExplicitSupportedLngs: true,
  debug: process.env.NODE_ENV === 'development',
  interpolation: {
    escapeValue: false, // React already does escaping
  },
  // Return the key if translation is missing (i18next will still try fallback first)
  returnNull: false,
  returnEmptyString: false,
});

// In non-test environments, don't wait for init (fire and forget)
// Tests can await initPromise to ensure initialization completes
if (typeof process !== 'undefined' && process.env.NODE_ENV !== 'test') {
  void initPromise;
}

// oxlint-disable-next-line import/no-default-export
export default i18n;
export { initPromise };
